import { Outlet, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { TopNavbar } from './top-navbar';
import { MobileDrawer } from './mobile-drawer';
import { ModernFooter } from './modern-footer';
import { useStoreInfo } from '@/lib/store';
import { Toaster } from 'react-hot-toast';
import { useEffect } from 'react';
import { MaintenancePage } from '../site-lock/maintenance';
import { InstallPrompt } from '../pwa/install-prompt';
import { useDynamicFavicon } from '@/hooks/useDynamicFavicon';
import { LockNotice } from '../site-lock/lock-notice';

export function RootLayout() {
  const location = useLocation();
  const { storeInfo, lockNoticeOpen, openLockNotice, closeLockNotice } = useStoreInfo();
  const [isMobileDrawerOpen, setIsMobileDrawerOpen] = useState(false);
  
  // Initialize dynamic favicon
  useDynamicFavicon();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    if (storeInfo?.site_lock === 1) {
      openLockNotice();
    }
  }, [storeInfo, openLockNotice]);

  if (storeInfo?.site_lock === 2) {
    return <MaintenancePage />;
  }

  return (
    <div className="flex min-h-screen flex-col bg-gray-50">
      <TopNavbar onMobileMenuOpen={() => setIsMobileDrawerOpen(true)} />
      <MobileDrawer isOpen={isMobileDrawerOpen} onClose={() => setIsMobileDrawerOpen(false)} />
      <main className="flex-1">
        <Outlet />
      </main>
      <ModernFooter />
      <InstallPrompt />
      <LockNotice open={lockNoticeOpen} onClose={closeLockNotice} />
      <Toaster 
        position="top-center"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#fff',
            color: '#374151',
            borderRadius: '12px',
            padding: '16px',
            boxShadow: '0 10px 40px -10px rgba(236, 72, 153, 0.2)',
          },
          success: {
            iconTheme: {
              primary: '#10B981',
              secondary: '#fff',
            },
          },
          error: {
            iconTheme: {
              primary: '#EF4444',
              secondary: '#fff',
            },
          },
        }}
      />
    </div>
  );
}